(() => {
  const GEO_ENDPOINTS = [
    'https://ipwho.is/',
    'https://get.geojs.io/v1/ip/country.json'
  ];

  // Manual display-only rates. Update this map whenever your reference rates change.
  const COUNTRY_TO_CURRENCY = {
    DEFAULT: { currency: 'USD', rate: 0.2725 },
    US: { currency: 'USD', rate: 0.2725 },
    AE: { currency: 'AED', rate: 1.0007 },
    JO: { currency: 'JOD', rate: 0.1932 },
    IQ: { currency: 'IQD', rate: 356.95 },
    SY: { currency: 'SYP', rate: 3542 },
    IL: { currency: 'ILS', rate: 1 },
    IN: { currency: 'ILS', rate: 1 },
    RU: { currency: 'RUB', rate: 25.07 },
    GB: { currency: 'GBP', rate: 0.2153 }
  };

  const TIMEZONE_TO_COUNTRY = [
    ['Asia/Dubai', 'AE'],
    ['Asia/Amman', 'JO'],
    ['Asia/Baghdad', 'IQ'],
    ['Asia/Kolkata', 'IN'],
    ['Asia/Calcutta', 'IN'],
    ['Asia/Damascus', 'SY'],
    ['Asia/Jerusalem', 'IL'],
    ['Europe/London', 'GB'],
    ['Europe/Kaliningrad', 'RU'],
    ['Europe/Moscow', 'RU'],
    ['Europe/Samara', 'RU'],
    ['Europe/Astrakhan', 'RU'],
    ['Europe/Volgograd', 'RU'],
    ['Europe/Saratov', 'RU'],
    ['Europe/Ulyanovsk', 'RU'],
    ['Europe/Kirov', 'RU'],
    ['Europe/Simferopol', 'RU'],
    ['Asia/Yekaterinburg', 'RU'],
    ['Asia/Omsk', 'RU'],
    ['Asia/Novosibirsk', 'RU'],
    ['Asia/Barnaul', 'RU'],
    ['Asia/Tomsk', 'RU'],
    ['Asia/Novokuznetsk', 'RU'],
    ['Asia/Krasnoyarsk', 'RU'],
    ['Asia/Irkutsk', 'RU'],
    ['Asia/Chita', 'RU'],
    ['Asia/Yakutsk', 'RU'],
    ['Asia/Khandyga', 'RU'],
    ['Asia/Vladivostok', 'RU'],
    ['Asia/Ust-Nera', 'RU'],
    ['Asia/Sakhalin', 'RU'],
    ['Asia/Srednekolymsk', 'RU'],
    ['Asia/Kamchatka', 'RU'],
    ['Asia/Anadyr', 'RU']
  ];

  const US_TIMEZONE_PREFIXES = [
    'America/New_York',
    'America/Detroit',
    'America/Kentucky/',
    'America/Indiana/',
    'America/Chicago',
    'America/North_Dakota/',
    'America/Denver',
    'America/Boise',
    'America/Phoenix',
    'America/Los_Angeles',
    'America/Anchorage',
    'America/Juneau',
    'America/Sitka',
    'America/Metlakatla',
    'America/Yakutat',
    'America/Nome',
    'America/Adak',
    'Pacific/Honolulu'
  ];

  function normalizeCountry(value) {
    const code = String(value || '').trim().toUpperCase();
    return COUNTRY_TO_CURRENCY[code] ? code : '';
  }

  function detectCountryFromTimezone() {
    const timezone = window.Intl && Intl.DateTimeFormat
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : '';

    if (!timezone) return '';

    const directMatch = TIMEZONE_TO_COUNTRY.find(([zone]) => zone === timezone);
    if (directMatch) return directMatch[1];

    const isUsTimezone = US_TIMEZONE_PREFIXES.some((prefix) => timezone.startsWith(prefix));
    return isUsTimezone ? 'US' : '';
  }

  async function fetchCountryFromEndpoint(url) {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) return '';

      const payload = await response.json();
      return normalizeCountry(payload.country_code || payload.country);
    } catch (error) {
      return '';
    }
  }

  async function detectCountryFromIp() {
    for (const endpoint of GEO_ENDPOINTS) {
      const country = await fetchCountryFromEndpoint(endpoint);
      if (country) return country;
    }
    return '';
  }

  function detectCountryFallback() {
    const timezoneCountry = detectCountryFromTimezone();

    if (timezoneCountry) {
      console.log('currency source: timezone', timezoneCountry);
      return timezoneCountry;
    }

    console.log('currency source: default', 'DEFAULT');
    return 'DEFAULT';
  }

  function formatMoney(cents, countryCode, withCurrency) {
    const market = COUNTRY_TO_CURRENCY[countryCode] || COUNTRY_TO_CURRENCY.DEFAULT;
    const amount = (Number(cents) / 100) * market.rate;
    const locale = countryCode === 'US' || countryCode === 'DEFAULT' ? 'en-US' : undefined;

    const options = {
      style: 'currency',
      currency: market.currency
    };

    if (!withCurrency) {
      options.currencyDisplay = 'narrowSymbol';
    }

    return new Intl.NumberFormat(locale, options).format(amount);
  }

  function localizeMoneyNode(node, countryCode) {
    if (!(node instanceof HTMLElement)) return;

    const cents = Number(node.dataset.baseCents || '0');
    const withCurrency = node.dataset.withCurrency === 'true';

    node.textContent = formatMoney(cents, countryCode, withCurrency);
    node.dataset.localizedCurrency = countryCode;
  }

  function localizeAll(countryCode, scope = document) {
    if (!scope || !scope.querySelectorAll) return;

    scope.querySelectorAll('[data-money-localized]').forEach((node) => {
      localizeMoneyNode(node, countryCode);
    });
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const ipCountry = await detectCountryFromIp();
    const countryCode = ipCountry || detectCountryFallback();

    if (ipCountry) {
      console.log('currency source: ip', ipCountry);
    }

    console.log('currency country:', countryCode);

    localizeAll(countryCode);

    if (!document.body) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches('[data-money-localized]')) {
            localizeMoneyNode(node, countryCode);
          }

          localizeAll(countryCode, node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
